// extracted by mini-css-extract-plugin
export default {"tr":"tableRow_tr__VpbgX","td":"tableRow_td__nrE8o"};